export const CHANGE_EDITION_POLL_INTERVAL_SECS = 3;
export const CHANGE_EDITION_POLL_DURATION_MINS = 1;

export const CCP_TRANSITION_WITH_UPFLOW_FF =
	'confluence.frontend.enable.ccp.seq4.upflow.transition';
